import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useNavigate } from "react-router-dom";
import { BiShow, BiHide } from "react-icons/bi";
import * as yup from "yup";
import logo from '../images/aizo-plan.png';
import axiosInstance from "../lib/axios";
const loginSchema = yup.object().shape({
    email: yup.string().email().required().label("Email"),
    password: yup.string().min(8).required().label("Password"),
});

const Login = () => {
    const {
        handleSubmit,
        register,
        formState: { errors, isSubmitting },
    } = useForm({
        resolver: yupResolver(loginSchema),
    });

    const navigate = useNavigate();
    const [loginErrorMessage, setLoginErrorMessage] = useState();
    const [showPassword, setShowPassword] = useState(false);

    // Mock submit function simulating WS consumption
    const submit = async ({ email, password }) => {
        setLoginErrorMessage("");
        try {
            const response = await axiosInstance.post('/admin/auth', JSON.stringify({ email, password }));

            if (response.status !== 200) {
                setLoginErrorMessage(
                    response.status === 401
                        ? "Email address or password is invalid. Please try again."
                        : response.status === 423
                            ? "Your account has been locked for security reasons."
                            : "An error occurred during authentication. Please try again."
                );
            } else {
                localStorage.setItem("accessToken", response.data.accessToken);
                localStorage.setItem("refreshToken", response.data.refreshToken);
                navigate(`/`);

                try {
                    const response2 = await axiosInstance.get('/admin/me');
                    if (response2.status === 200) {
                        localStorage.setItem("userInfo", JSON.stringify(response2.data.profile));
                    } else {
                        console.log("Failed to retrieve user profile information.");
                    }
                } catch (error) {
                    console.error("Error fetching user profile:", error);
                }
            }
        } catch (error) {
            console.error("Error during authentication:", error);
            setLoginErrorMessage("An error occurred during authentication. Please try again.");
        }
    };


    useEffect(() => {
        console.log("Page view logged");
    }, []);

    const togglePasswordVisibility = () => setShowPassword(!showPassword);

    return (
        <div className="min-w-[100vw] min-h-[100vh]  flex items-center justify-center ">
            <div className="h-full  flex flex-col min-w-[30vw] items-center justify-center gap-6 max-w-md mx-auto py-20">
                <img className=" p-1" src={logo} width="300" height="40" alt="logo" />
                {/* <div className="w-full text-center">
                      <h1 className="text-2xl font-semibold text-gray-800">Sign In</h1>
                   </div> */}
                <form onSubmit={handleSubmit(submit)} className="w-full flex flex-col gap-4">
                    {!isSubmitting && loginErrorMessage && (
                        <div role="alert" className="alert alert-error">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="stroke-current shrink-0 h-6 w-6"
                                fill="none"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                                />
                            </svg>
                            <span>{loginErrorMessage}</span>
                        </div>
                    )}

                    <label className="form-control w-full">
                        <span className="label-text text-labelGray font-semibold leading-5">
                            Email
                        </span>
                        <input
                            type="email"
                            className="input input-bordered w-full border-gray-300"
                            {...register("email")}
                        />
                    </label>

                    <label className="form-control w-full">
                        <span className="label-text text-labelGray font-semibold leading-5">
                            Password
                        </span>
                        <div className="flex items-center gap-2 input input-bordered bg-white w-full border-gray-300">
                            <input
                                type={showPassword ? "text" : "password"}
                                className="flex-grow border-none text-gray-950"
                                {...register("password")}
                            />
                            {showPassword ? (
                                <BiShow onClick={togglePasswordVisibility} className="text-gray-400 text-xl cursor-pointer" />
                            ) : (
                                <BiHide onClick={togglePasswordVisibility} className="text-gray-400 text-xl cursor-pointer" />
                            )}
                        </div>

                    </label>

                    <button className="btn bg-indigo-500 hover:bg-indigo-600 text-white" disabled={isSubmitting}>
                        {isSubmitting && <span className="loading loading-spinner"></span>}
                        Sign In
                    </button>
                </form>
            </div>
        </div>

    );
};

export default Login;
